import type { EntityData } from "@/types/entity";
import type { SelectedService } from "@/types/service";
import { createLocalStorageNamespace } from "./createLocalStorageNamespace";

export interface UnauthenticatedEntityData {
  entityData: EntityData;
  selectedServices: SelectedService[];
  currentStep: number;
  timestamp: string;
}

const store = createLocalStorageNamespace<UnauthenticatedEntityData>({
  namespace: "nis2_unauthenticated_entity_data",
});

export const saveUnauthenticatedEntityData = (
  entityData: EntityData,
  selectedServices: SelectedService[],
  currentStep: number
): void => {
  store.save({
    entityData,
    selectedServices,
    currentStep,
    timestamp: new Date().toISOString(),
  });
};

export const getUnauthenticatedEntityData =
  (): UnauthenticatedEntityData | null => store.get();

export const clearUnauthenticatedEntityData = (): void => store.clear();

export const hasUnauthenticatedEntityData = (): boolean =>
  store.get() !== null;

export const updateUnauthenticatedEntityStep = (newStep: number): void => {
  const existing = store.get();
  if (!existing) return;
  store.save({
    ...existing,
    currentStep: newStep,
    timestamp: new Date().toISOString(),
  });
};
